import AgentActivity from 'models/agent_activity';
import CustomerView from 'models/location/customer_view';
import FetchAnswerSuggestions from 'actions/answer_suggestions/fetch_answer_suggestions';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import CompositionContentType from 'models/composition/composition_content_type';
import ConversationItemType from 'models/conversation_item_type';

export default function changeComposition(context, composition) {
  let currentLocation = context.stores.currentLocation.get();
  if (!(currentLocation instanceof CustomerView)) {
    return;
  }

  if (composition) {
    context.executeAction(SetAndLogActivity, {
      type: AgentActivity.Type.COMPOSITION_OPEN,
      channel:
        composition.contentType() === ConversationItemType.CONVERSATION_MESSAGE
          ? composition.content.channel
          : composition.contentType(),
    });
  } else {
    context.executeAction(SetAndLogActivity, {
      type: AgentActivity.Type.COMPOSITION_CLOSE,
    });
  }

  // Do not scroll if a task edit
  if (composition && composition.contentType() === CompositionContentType.TASK_EDIT) {
    currentLocation.changeCurrentConversationItem(composition.content.conversationItemId);
  }

  currentLocation.changeCurrentComposition((composition && composition.id) || null);
  context.stores.currentLocation.set(currentLocation);

  if (composition) {
    context.executeAction(FetchAnswerSuggestions, composition);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/lib/change_composition.js